import api, { unwrap } from '../client';

// Rentabilité client 2 étapes — prestations + heures timbrées.
const base = (tid, year) => `/tdabc/rc/${tid}/${year}`;

export const listPrestations   = (tid, year)            => unwrap(api.get(`${base(tid, year)}/prestations`));
export const createPrestation  = (tid, year, payload)   => unwrap(api.post(`${base(tid, year)}/prestations`, payload));
export const patchPrestation   = (tid, year, id, patch) => unwrap(api.patch(`${base(tid, year)}/prestations/${id}`, patch));
export const deletePrestation  = (tid, year, id)        => unwrap(api.delete(`${base(tid, year)}/prestations/${id}`));

export const listRcHours       = (tid, year)            => unwrap(api.get(`${base(tid, year)}/hours`));
export const upsertRcHours     = (tid, year, payload)   => unwrap(api.put(`${base(tid, year)}/hours`, payload));
export const bulkRcHours       = (tid, year, items)     => unwrap(api.post(`${base(tid, year)}/hours/bulk`, { items }));
